import { render, staticRenderFns } from "./RestaurantOrderProvidersListCard.vue?vue&type=template&id=48a157c7"
import script from "./RestaurantOrderProvidersListCard.vue?vue&type=script&lang=ts"
export * from "./RestaurantOrderProvidersListCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports